import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function trimmedMaxLengthValidator(maxLength: number): ValidatorFn {
    return function (control: AbstractControl): ValidationErrors | null {
        const value = control.value?.trim();

        return value?.length > maxLength ? { maxlength: { actualLength: value?.length, requiredLength: maxLength } } : null;
    };
}
